<template>
  <v-row>
    <v-col cols="6">
      <div class="d-flex gap-10 align-center">
        <i class="icon-Other-Build icon-font-35"></i>
        <span class="font-w-500 text-red" style="font-size: 28px">
          รายละเอียดร้านค้า
        </span>
      </div>
    </v-col>
    <v-col cols="6">
      <div class="d-flex gap-10 align-center justify-end">
        <span class="font-16 font-w-500">Sub Dealer :</span>
        <div v-if="bpDetail.class === 'A'" class="icon-sub-dealer--a">
          <span>A</span>
        </div>
        <div v-if="bpDetail.class === 'B'" class="icon-sub-dealer--b">
          <span>B</span>
        </div>
        <div v-if="bpDetail.class === 'C'" class="icon-sub-dealer--c">
          <span>C</span>
        </div>
        <div v-if="bpDetail.class === 'D'" class="icon-sub-dealer--d">
          <span>D</span>
        </div>
        <div v-if="bpDetail.class === 'E'" class="icon-sub-dealer--e">
          <span>E</span>
        </div>
      </div>
    </v-col>
    <v-col cols="12" sm="6" md="3">
      <span class="font-16 font-w-500">BP No. : </span>
      <span class="font-16 font-grey">{{ bpDetail.ScgBPNumber || "-" }}</span>
    </v-col>
    <v-col cols="12" sm="6" md="3">
      <span class="font-16 font-w-500">BP Province. : </span>
      <span class="font-16 font-grey">{{ bpDetail.bp_province || "-" }}</span>
    </v-col>
    <v-col cols="12" sm="12" md="6">
      <span class="font-16 font-w-500">BP District. : </span>
      <span class="font-16 font-grey">{{ bpDetail.bp_district || "-" }}</span>
    </v-col>
    <v-col cols="12" class="d-flex align-center gap-8">
      <i class="icon-History text-red font-18"></i>
      <span class="font-16 font-w-500">วันที่เข้าเยี่ยมล่าสุด : </span>
      <span class="font-16 font-w-500 font-grey">
        {{ bpDetail.last_visit_date || "-" }}
      </span>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    bpDetail: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="scss" scoped>
.icon-sub-dealer {
  width: 32px;
  height: 32px;
  padding: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  color: #fff;

  &--a {
    @extend .icon-sub-dealer;
    background: #fdd14c;
  }
  &--b {
    @extend .icon-sub-dealer;
    background: #eeb893;
  }
  &--c {
    @extend .icon-sub-dealer;
    background: #eda06e;
  }
  &--d {
    @extend .icon-sub-dealer;
    background: #b34408;
  }
  &--e {
    @extend .icon-sub-dealer;
    background: #6e2c08;
  }
}
</style>
